import { useState } from 'react';
import { Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { TComponent } from 'utils/types/component';

import { TabButton } from 'components/ui/TabButton';

import styles from './MerchantCard.module.scss';

export enum TabType {
    Common = 'common',
    Deposits = 'deposits',
    Payouts = 'payouts',
}

interface IMerchantCardProps {
    currencyCode: string;
    commonContent: React.ReactNode;
    depositsContent: React.ReactNode;
    payoutsContent: React.ReactNode;
}

const tabList: { key: TabType; label: string }[] = [
    {
        key: TabType.Common,
        label: 'balance.tabs.common',
    },
    {
        key: TabType.Deposits,
        label: 'balance.tabs.deposits',
    },
    {
        key: TabType.Payouts,
        label: 'balance.tabs.payouts',
    },
];

export const MerchantCard: TComponent<IMerchantCardProps> = ({
    commonContent,
    depositsContent,
    payoutsContent,
    currencyCode,
}) => {
    const [activeTab, setActiveTab] = useState<TabType>(TabType.Common);
    const { t } = useTranslation();

    const handleTabChange = (key: TabType) => {
        setActiveTab(key);
    };

    const contentMap = {
        common: commonContent,
        deposits: depositsContent,
        payouts: payoutsContent,
    };

    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <Typography.Text className={styles.currencyCode}>
                    {currencyCode}
                </Typography.Text>
                <Space>
                    {tabList.map(({ key, label }) => (
                        <TabButton
                            key={key}
                            type={key}
                            isActive={activeTab === key}
                            onClick={() => handleTabChange(key)}
                            label={t(label)}
                        />
                    ))}
                </Space>
            </div>
            <div className={styles.content}>{contentMap[activeTab]}</div>
        </div>
    );
};
